import { useTheme } from '@mui/material';
import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQ`,
  description: `Zero-Knowledge Proof Development Services with Rumble Fish`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'Q: What is a ZK Proof?',
      description: `A: A zero-knowledge proof is a cryptographic method that allows one party (the prover) to prove to another party (the verifier) that they know a specific piece of information, without revealing the actual information itself. Think of it as proving you know the password to a vault without ever saying what the password is. In blockchain applications, ZK proofs enable privacy-preserving transactions, scalable computations, and regulatory compliance. For example, you could prove you're over 18 without showing your birthdate, or prove you have sufficient funds for a transaction without revealing your account balance. The technology maintains three key properties: completeness (valid proofs are always accepted), soundness (invalid proofs are always rejected), and zero-knowledge (no information beyond the validity of the statement is revealed).`,
      gradientOnFocus: theme.mixins.cyanGradient?.background as string,
    },
    {
      title: 'Q: How long does ZK development take?',
      description: `A: Depends on complexity. Simple proofs of concept: 3-4 weeks. Production systems: 3-6 months. We'll give you realistic timelines upfront.`,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      title: 'Q: Are zero-knowledge proofs really secure?',
      description: `A: When implemented correctly, yes. ZK proofs are mathematically sound and computationally secure. The key is proper implementation—which is where we come in.`,
      gradientOnFocus: theme.mixins.violetGradient?.background as string,
    },
    {
      title: "Q: What's the performance like?",
      description: `A: Modern ZK systems can generate proofs in seconds and verify them in milliseconds. Our Original Works case study reduced processing from 16 hours to 3 minutes.`,
      gradientOnFocus: theme.mixins.grapeGradient?.background as string,
    },
    {
      title: 'Q: Do you work with existing codebases?',
      description: `A: Absolutely. We specialize in integrating ZK proofs into existing systems with minimal disruption to your current architecture.`,
      gradientOnFocus: theme.mixins.purpleGradient?.background as string,
    },
    {
      title: 'Q: What about gas costs?',
      description: `A: ZK rollups can reduce Ethereum gas costs by 99%+. Even direct mainnet verification is becoming more affordable with protocol improvements.`,
      gradientOnFocus: theme.mixins.magentaGradient?.background as string,
    },
    {
      title: 'Q: Can you explain this without the technical jargon?',
      description: `A: Sure! ZK proofs let you prove something is true without revealing any details about how you know it's true. Like proving you're over 21 without showing your ID.`,
      gradientOnFocus: theme.mixins.raspberryGradient?.background as string,
    },
  ];
};
